// import { UAParser } from 'ua-parser-js';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { Platform } from '@angular/cdk/platform';
import { CommonModule, DatePipe, JsonPipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Signal,
  WritableSignal,
  computed,
  effect,
  inject,
  signal,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import dayjs from 'dayjs';
import { NgxPrintModule, NgxPrintService, PrintOptions } from 'ngx-print';
import { ConfirmationDialogComponent } from '../../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { AgeStringPipe } from '../../../../pipes/age-string.pipe';
import { AssessmentNotesPipe } from '../../../../pipes/assessment-notes.pipe';
import { GenderStringPipe } from '../../../../pipes/gender-string.pipe';
import { MonthStringPipe } from '../../../../pipes/month-string.pipe';
import { SideStringPipe } from '../../../../pipes/side-string.pipe';
import { AssessmentsService } from '../../../../services/assessments.service';
import { LogService } from '../../../../services/log.service';
import {
  Assessment,
  AssessmentChartDataSets,
  IcfCategory,
  Patient,
  ReportItem,
  icfCategoryLabels,
} from '../../../../services/model';
import { OfficeService } from '../../../../services/office.service';
import { PatientsService } from '../../../../services/patients.service';
import { GraphComponent } from '../../graph/graph.component';
import { IcfDescriptionTableComponent } from '../icf-description-table/icf-description-table.component';
import { ReportRowComponent } from '../report-row/report-row.component';

@Component({
  selector: 'app-report-table',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    JsonPipe,
    MatTableModule,
    MonthStringPipe,
    GenderStringPipe,
    AgeStringPipe,
    SideStringPipe,
    DatePipe,
    AssessmentNotesPipe,
    MatIconModule,
    RouterModule,
    ReportRowComponent,
    NgxPrintModule,
    GraphComponent,
    MatCheckboxModule,
    MatExpansionModule,
    CdkAccordionModule,
    IcfDescriptionTableComponent,
  ],
  templateUrl: './report-table.component.html',
  styleUrl: './report-table.component.scss',
})
export class ReportTableComponent implements OnInit {
  @Input() patientId?: string;
  @Output() isPrinting = new EventEmitter<boolean>(false);
  patient: WritableSignal<Patient | undefined> = signal(undefined);
  printing: boolean = false;
  isCategoryDescriptionsEnabled: boolean = true;
  officeName: string = '';
  currentDate: Date = new Date();

  public platform: Platform = inject(Platform);
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private assessmentsService: AssessmentsService = inject(AssessmentsService);
  private officeService: OfficeService = inject(OfficeService);
  private patientsService: PatientsService = inject(PatientsService);
  private printService: NgxPrintService = inject(NgxPrintService);
  private logger: LogService = inject(LogService);
  private dialog: MatDialog = inject(MatDialog);

  icfCategoryLabels: { [key in IcfCategory]: string } = icfCategoryLabels;
  reportList: WritableSignal<ReportItem[] | undefined> = this.assessmentsService.reportList;
  reportNotesLastUpdatedTime: Signal<number> = this.assessmentsService.reportNotesLastUpdatedTime;
  showIcfScoreReviewWarning: Signal<boolean> = computed(() => {
    let lastUpdatedTime: number;

    const lastIcfUpdateTime: string | undefined = this.patient()?.lastIcfUpdateTime;
    if (lastIcfUpdateTime === undefined) {
      // Zeitpunkt wurde noch nicht gesetzt (user hat noch nie bestätigt). Um herauszufinden, ob der User schonmal einen ICF-Score gesetzt hat:
      const lastReportNotesUpdatedTime = this.reportNotesLastUpdatedTime();
      // ... und dann nur für diesen fall als ausgangspunkt nehmen:
      lastUpdatedTime = lastReportNotesUpdatedTime;
      // console.log('lastUpdatedTime1', {
      //   patient: this.patient()?.lastIcfUpdateTime,
      //   lastUpdatedTime: dayjs(lastUpdatedTime).format('YYYY-MM-DD HH:mm:ss'),
      //   lastReportNotesUpdatedTime: dayjs(lastReportNotesUpdatedTime).format('YYYY-MM-DD HH:mm:ss'),
      //   lastIcfUpdateTime:
      //     lastIcfUpdateTime == undefined ? undefined : dayjs(lastIcfUpdateTime).format('YYYY-MM-DD HH:mm:ss'),
      // });
    } else {
      // ansonsten gilt immer der Zeitpunkt wann der user zuletzt BESTÄTIGT hat:
      lastUpdatedTime = dayjs(lastIcfUpdateTime).toDate().getTime();
    }

    // // das jüngere Datum zählt:
    // const lastUpdatedTime =
    //   lastIcfUpdateTime !== undefined && dayjs(lastIcfUpdateTime).toDate().getTime() > lastReportNotesUpdatedTime
    //     ? dayjs(lastIcfUpdateTime).toDate().getTime()
    //     : lastReportNotesUpdatedTime;
    // console.log('lastUpdatedTime2', {
    //   patient: this.patient()?.lastIcfUpdateTime,
    //   lastUpdatedTime: dayjs(lastUpdatedTime).format('YYYY-MM-DD HH:mm:ss'),
    //   // lastReportNotesUpdatedTime: dayjs(lastReportNotesUpdatedTime).format('YYYY-MM-DD HH:mm:ss'),
    //   lastIcfUpdateTime:
    //     lastIcfUpdateTime == undefined ? undefined : dayjs(lastIcfUpdateTime).format('YYYY-MM-DD HH:mm:ss'),
    // });

    const reportItems = this.reportList();
    if (reportItems && lastUpdatedTime > 0 && this.patient() !== undefined) {
      return reportItems.some(item => {
        console.log('details ', item.details, item.assessmentTypes);
        return item.details?.some(detail => {
          const isAssessmentLater = dayjs(detail.dateIso).toDate().getTime() >= lastUpdatedTime;
          // console.log('isAssessmentLater', {
          //   date: dayjs(detail.dateIso).format('YYYY-MM-DD HH:mm:ss'),
          //   isAssessmentLater,
          // });

          return isAssessmentLater;
        });
      });
    }
    return false;
  });

  lastIcfUpdateTimeGermanDate: Signal<string> = computed(() =>
    dayjs(this.patient()?.lastIcfUpdateTime).format('DD.MM.YYYY')
  );

  assessmentChartDataSets: Signal<AssessmentChartDataSets | undefined> =
    this.assessmentsService.assessmentChartDataSets.asReadonly();
  assessmentChartDataSetCount: Signal<number> = computed(() => {
    const sets = this.assessmentChartDataSets();
    if (sets) {
      const anzahl = Object.keys(sets).length;
      // console.log('anzahl print sets ' + anzahl);

      return anzahl;
    } else {
      return 0;
    }
  });

  tableColumns = ['date', 'type', 'score', 'note', 'buttons'];

  damageLevels = [
    { icf: 4, min: 96, max: 100, color: '#F4856D' }, // Schädigung voll ausgeprägt
    { icf: 3, min: 50, max: 95, color: '#EEB27B' }, // Schädigung erheblich ausgeprägt
    { icf: 2, min: 25, max: 49, color: '#E8E596' }, // Schädigung mäßig ausgeprägt
    { icf: 1, min: 5, max: 24, color: '#F4F7D0' }, // Schädigung leicht ausgeprägt
    { icf: 0, min: 0, max: 4, color: '#b1dd5f7d' }, // Schädigung nicht vorhanden
  ];

  constructor() {
    const effectRef = effect(
      () => {
        const office = this.officeService.office();
        // console.log('chris effect', office);
        // console.log('chris office()?.isCategoryDescriptionsEnabled', office?.isCategoryDescriptionsEnabled);

        if (office) {
          this.isCategoryDescriptionsEnabled = this.officeService.office()?.isCategoryDescriptionsEnabled ?? true;
          this.officeName = this.officeService.office()?.name ?? '';
          effectRef.destroy();
        }
      },
      { manualCleanup: true }
    );

    // const parser = new UAParser();
    // console.log(parser.getResult());
  }

  ngOnInit(): void {
    console.log('patientID', this.patientId);
    this.logger.log('report for ' + location.href);
    if (this.patientId !== undefined) {
      this.patientsService.getPatient(this.patientId).then(patient => {
        this.patient.set(patient);
        this.assessmentsService.getAssessments();
      });
    }
    console.log('browser: ', {
      ANDROID: this.platform.ANDROID,
      EDGE: this.platform.EDGE,
      FIREFOX: this.platform.FIREFOX,
      IOS: this.platform.IOS,
      SAFARI: this.platform.SAFARI,
      WEBKIT: this.platform.WEBKIT,
      BLINK: this.platform.BLINK,
      TRIDENT: this.platform.TRIDENT,
    });

    // wenn der bericht für den Patienten betreten wird und noch kein
    // lastIcfUpdateTime gesetzt ist, setzten wir es hier einmalig, damit es nicht leer ist.
    // -> das geht nicht, weil ja dann schon bei der ersten testung die warnung käme...
    // if (this.patient() && this.patient()?.lastIcfUpdateTime === undefined) {
    //   console.log('LEER: lastIcfUpdateTime. Init now');
    //   this.onApplyAllIcfScoresChecked();
    // }
  }

  newAssessment() {
    this.router.navigate(['../../assessments/new'], { relativeTo: this.route });
  }

  navigateToAssessment(assessment: Assessment) {
    console.log('ass', assessment);
    if (assessment) {
      this.router.navigate(['../../assessments/' + assessment.type.toLowerCase() + '/' + assessment._documentId], {
        relativeTo: this.route,
      });
    }
  }

  deleteAssessment(assessment: Assessment) {
    if (assessment?._documentId) {
      this.assessmentsService.deleteAssessment(assessment._documentId);
    }
  }

  search() {}

  onApplyAllIcfScoresChecked() {
    const patientUpdate = this.patient()!;
    patientUpdate.lastIcfUpdateTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
    this.patientsService
      .updatePatient(patientUpdate)
      .then(result => {
        console.log('onApplyAllIcfScoresChecked', result);
        this.patientsService.getPatient(this.patientId!).then(patient => {
          this.patient.set(patient);
        });
      })
      .catch(error => {
        console.log('onApplyAllIcfScoresChecked An error occurred', { ...error });
      });
  }

  onApplyAllIcfScoresClicked() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '450px',
      data: {
        title: 'Bestätigung erforderlich',
        description:
          'Bitte bestätigen Sie, dass Sie für alle ICF-Kategorien die durchschnittliche Schädigung laut Assessments als ICF-Score übernehmen möchten. Die bisher eingetragenen ICF-Scores werden dabei überschrieben.',
        buttonTitleYes: 'Übernehmen',
        buttonTitleNo: 'Abbrechen',
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'YES') {
        this.applyAllIcfScores();
      }
    });
  }

  applyAllIcfScores() {
    const reportItems = this.reportList();
    if (reportItems) {
      // Apply ICF scores logic here
      // For each report item, set the appropriate ICF score based on assessment data
      this.reportList.update(items => {
        if (items) {
          return items.map(item => {
            let icfScore: number = 4;
            for (const level of this.damageLevels) {
              const value = item.scoreAverage ?? 0;
              if (value >= level.min && value <= level.max) {
                icfScore = level.icf;
              }
            }
            // Wenn neuer ICF-Score, dann speichern
            if (item.icfScoreSelected !== icfScore) {
              this.assessmentsService.createOrUpdateReportNote({
                icfScoreSelected: icfScore,
                icfCategory: item.icfCategory!,
              });
            }
            // Set the ICF score for the item
            item.icfScoreSelected = icfScore;
            return item;
          });
        }
        return items;
      });
    }
  }

  onChangeCategoryDesciptionEnabled() {
    const office = this.officeService.office()!;
    office.isCategoryDescriptionsEnabled = this.isCategoryDescriptionsEnabled;
    this.officeService.updateOffice(office);
    // console.log('chris ' + this.isCategoryDescriptionsEnabled, this.isCategoryDescriptionsEnabled);
  }

  printSimple() {
    // window.print();
    this.logger.log('print');
    this.printing = true;
    this.isPrinting.emit(true);
    this.currentDate = new Date();

    setTimeout(() => {
      // this.printService.print(customPrintOptions);
      setTimeout(() => {
        this.printing = false;
        this.isPrinting.emit(false);
      }, 1000);

      window.print();
    }, 2000);
  }

  printOLD() {
    const customPrintOptions: PrintOptions = new PrintOptions({
      printSectionId: 'print-section',
      useExistingCss: true,
      previewOnly: true,
      printDelay: 500,
    });
    this.printing = true;
    this.isPrinting.emit(true);

    setTimeout(() => {
      this.printService.print(customPrintOptions);
      setTimeout(() => {
        this.printing = false;
        this.isPrinting.emit(false);
      }, 1100);
    }, 500);
    // window.print();
  }
}
